module.exports={
  "alex-gruenenfelder": {
    "name": "Alex Gruenenfelder",
    "lastName": "Gruenenfelder",
    "label": "AG",
    "image": "alex-gruenenfelder.png",
    "party": "U",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "craig-greiwe": {
    "name": "Craig Greiwe",
    "lastName": "Greiwe",
    "label": "CG",
    "image": "craig-greiwe.png",
    "party": "U",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "gina-viola": {
    "name": "Gina Viola",
    "lastName": "Viola",
    "label": "GV",
    "image": "gina-viola.png",
    "party": "U",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "karen-bass": {
    "name": "Karen Bass",
    "lastName": "Bass",
    "label": "KB",
    "image": "karen-bass.png",
    "party": "D",
    "pronoun": "she",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "kevin-de-leon": {
    "name": "Kevin de León",
    "lastName": "de León",
    "label": "KL",
    "image": "kevin-de-leon.png",
    "party": "D",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "mel-wilson": {
    "name": "Mel Wilson",
    "lastName": "Wilson",
    "label": "MW",
    "image": "mel-wilson.png",
    "party": "U",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  },
  "rick-caruso": {
    "name": "Rick Caruso",
    "lastName": "Caruso",
    "label": "RC",
    "image": "rick-caruso.png",
    "party": "U",
    "pronoun": "he",
    "droppedOut": "",
    "droppedOutDate": "",
    "nonResponsive": ""
  }
}